"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var routes_1 = require("@dynamynd/routes");

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var redux_1 = require("redux");

var styled_components_1 = __importDefault(require("styled-components"));

var app_1 = require("../../config/app");

var LogoContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: auto;\n    height: ", "px;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n"], ["\n    width: auto;\n    height: ", "px;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      theme = _a.theme;
  return responsive_1.isSmall(activeBreakpoint) ? theme.view.logo.small.height : theme.view.logo.large.height;
});
var LogoImage = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      theme = _a.theme;
  var small = responsive_1.isSmall(activeBreakpoint);
  var _b = theme.view.logo,
      logoSmall = _b.small,
      logoLarge = _b.large;
  return "\n            width: " + (small ? logoSmall.width : logoLarge.width) + "px;\n            height: " + (small ? logoSmall.height : logoLarge.height) + "px;\n        ";
});
var logos = app_1.appConfig.logos;

var LogoMascot =
/** @class */
function (_super) {
  __extends(LogoMascot, _super);

  function LogoMascot() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.pressHandler = function () {
      var _a = _this.props,
          navigateTo = _a.navigateTo,
          navigationExtraParams = _a.navigationExtraParams;

      if (_this.shouldNavigateToHome()) {
        navigateTo(routes_1.RoutesKeysEnum.home, navigationExtraParams);
      }
    };

    _this.shouldNavigateToHome = function () {
      return core_1.locationWebService.getActivePathName() !== routes_1.RoutesKeysEnum.take;
    };

    return _this;
  }

  LogoMascot.prototype.render = function () {
    var _a = this.props,
        color = _a.color,
        activeBreakpoint = _a.activeBreakpoint,
        version = _a.version;
    var uri = getLogoUrl(activeBreakpoint, version, color);
    return react_1.default.createElement(react_native_1.TouchableWithoutFeedback, {
      onPress: this.pressHandler,
      testID: this.props.testID
    }, react_1.default.createElement(LogoContainer, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(LogoImage, {
      activeBreakpoint: activeBreakpoint,
      source: {
        uri: uri
      },
      resizeMode: "contain"
    })));
  };

  return LogoMascot;
}(react_1.Component);

function getLogoUrl(activeBreakpoint, version, color) {
  if (version) {
    if (responsive_1.isSmall(activeBreakpoint)) {
      var sm = version.sm;
      return sm === 'text' ? logos.logoText : color === 'white' ? logos.logoWhite : logos.logoPurple;
    }

    var lg = version.lg;
    return lg === 'text' ? logos.logoText : color === 'white' ? logos.logoWhite : logos.logoPurple;
  }

  return logos.logoPurple;
}

var hoc = redux_1.compose(core_1.withNavigateTo, responsive_1.withResponsiveMeta);
exports.default = hoc(LogoMascot);
var templateObject_1, templateObject_2;